// Translations
import { useTrans } from "@/i18n"

// Hooks
import { useCurrentProject } from "../hooks"

// UI
import { CardWrapper } from "@/components/Card"
import { GraphLabels } from "@/components/graphs/GraphLabels"
import { ErrorBoundaryWithErrorState } from "@/components/errors/ErrorBoundary"
import { ProjectGraphCumulativeProduction } from "../components/ProjectGraphCumulativeProduction"
import { ProjectGraphProductionDaily } from "../components/ProjectGraphDailyProduction"
import { ProjectGraphProduction } from "../components/ProjectGraphProduction"
import { ProjectGraphProductionHeader } from "../components/ProjectGraphProductionHeader"
import { ProjectGraphProductionActions } from "../components/ProjectGraphProductionActions"

// Graphs
import { AreaGraph } from "@/components/graphs/types/area/AreaGraph"
import { ProductionGraph } from "@/components/graphs/types/bar/ProductionGraph"
import { ProductionCumulative } from "@/components/graphs/types/stacked-area/ProductionCumulative"

/**
 *
 * @returns ProjectProduction
 */
export const ProjectProduction = () => {
	// I18n
	const t = useTrans(["project", "common"])

	// Queries
	const { data } = useCurrentProject()

	return (
		<>
			<title>
				{t("common:web.title", {
					page: t("project:data.page_title", {
						projectName: data?.project?.name,
					}),
				})}
			</title>
			<div className="grid grid-cols-1 gap-8 md:grid-cols-4">
				{/** Production Dail (Area graph) */}
				<CardWrapper className="flex md:col-span-4">
					<div className="w-full">
						<ErrorBoundaryWithErrorState>
							<AreaGraph>
								<AreaGraph.Content>
									<ProjectGraphProductionDaily />
								</AreaGraph.Content>
							</AreaGraph>
						</ErrorBoundaryWithErrorState>
					</div>
				</CardWrapper>

				{/** Production period (Bar graph) */}
				<CardWrapper className="md:col-span-4">
					<ErrorBoundaryWithErrorState>
						<ProductionGraph>
							<ProductionGraph.Header>
								<ProjectGraphProductionHeader />
							</ProductionGraph.Header>
							<ProductionGraph.Actions>
								<ProjectGraphProductionActions />
							</ProductionGraph.Actions>
							<ProductionGraph.Content>
								<ProjectGraphProduction />
							</ProductionGraph.Content>
							<ProductionGraph.Footer>
								<GraphLabels className="p-3 px-4 sm:p-5 sm:px-6">
									<GraphLabels.TotalProduction />
									<GraphLabels.ExpectedProduction />
								</GraphLabels>
							</ProductionGraph.Footer>
						</ProductionGraph>
					</ErrorBoundaryWithErrorState>
				</CardWrapper>

				{/** Production cummulative (Stacked Area) */}
				<CardWrapper className="md:col-span-4">
					<ErrorBoundaryWithErrorState>
						<ProductionCumulative>
							<ProductionCumulative.Content>
								<ProjectGraphCumulativeProduction />
							</ProductionCumulative.Content>
							<ProductionCumulative.Footer>
								<GraphLabels className="px-4 pb-3 sm:px-6 sm:pb-5">
									<GraphLabels.TotalProduction />
									<GraphLabels.ExpectedProduction />
								</GraphLabels>
							</ProductionCumulative.Footer>
						</ProductionCumulative>
					</ErrorBoundaryWithErrorState>
				</CardWrapper>
			</div>
		</>
	)
}
